import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import Button from '../../atoms/button/button';
import cancelIcon from '../../../assets/cancelar.svg';
import Otp from '../otp/otp';
import './tratamientoDatos.scss'
import GoBackButton from '../../atoms/go-back-button/goBackButton';
import { TratamientoDatosText } from '../../../shared/src/components/atoms/tratamientoDatosPersonales/TratamientoDatosText';


const TratamientoDatos = () => {
	const [rechazar, setReachazar] = useState(false);
	const [aceptar, setAceptar] = useState(false);
	const navigate = useNavigate();
	const dockRef = useRef(null);

	const onClickReject = () => {
		setReachazar(true);
		setAceptar(false);
	}

	const startDiagnostic = () => {
		setReachazar(false);
		setAceptar(true);
		navigate('/formulario-salud-educacion-financiera/preguntas');
	}

	const showOtpScreen = () => {
		setReachazar(false);
		setAceptar(true);
	}

	const onClickReset = () => {
		setReachazar(false);
		setAceptar(false);
	}

	return (
		<div className="tratamiento-datos" ref={dockRef}>
			{(!rechazar && !aceptar) ? <>
				<main className="tratamiento-datos__body">
					<GoBackButton onClick={() => navigate("/formulario-inicial/")}/>
					<h1>Autorización de tratamiento de datos</h1>
					<TratamientoDatosText/>
					<span className="tratamiento-datos__body__info">
						<p>Para conocer la politica de protección de datos de personas de Comfama, <a className="tratamiento-datos__body__link" href='https://serviciosenlinea.comfama.com/webinicio/HabeasData.htm' target='_blank'>haz clic acá</a></p>
					</span>
					{/* TODO: Estos controles  */}
					<div className="tratamiento-datos__body__controls">
						<Button
							type={"button"}
							className="tratamiento-datos__body__controls__button"
							text="Rechazar"
							gtmClass="primary"
							onClick={onClickReject}
						/>
						<Button
							onClick={showOtpScreen}
							type={"button"}
							className="tratamiento-datos__body__controls__button"
							text="Aceptar"
							gtmClass="secondary"
						/>
					</div>
				</main>
			</> : (!aceptar && rechazar) ?
				<div className="tratamiento-datos-rejected">
					<GoBackButton onClick={onClickReset}/>
					<div className="tratamiento-datos-rejected__header">
						<h2 className="tratamiento-datos-rejected__header__title">Autorización de tratamiento de datos</h2>
						<img src={cancelIcon} alt="Cancelar tratamiento de datos" />
						<h3 className="tratamiento-datos-rejected__header__subtitle">Elegiste no permitir el tratamiento de tus datos personales</h3>
						<p className="tratamiento-datos-rejected__header__text">Por lo tanto no podemos continuar con el diagnóstico</p>
					</div>
					<h4 className='tratamiento-datos-rejected__bottom-text'>¿Quieres regresar y aprobar el tratamiento de tus datos?</h4>
					<div className="tratamiento-datos__body__controls">
						<Button
							type={"button"}
							className="tratamiento-datos__body__controls__button"
							text="Sí"
							gtmClass="primary"
							onClick={onClickReset}
						/>
						<Button
							onClick={onClickReset}
							type={"button"}
							className="tratamiento-datos__body__controls__button"
							text="No"
							gtmClass="secondary"
						/>
					</div>
				</div> :
				<>
					<Otp handleCorrectCode={startDiagnostic} handleGoBack={onClickReset} />
				</>
			}
		</div>
	)
}

export default TratamientoDatos